exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._28KHw38bf_5u1TG2iqsZyb{padding-inline-start:20px;padding-inline-end:20px}@media only screen and (min-width: 480px){._28KHw38bf_5u1TG2iqsZyb{padding-inline-start:36px;padding-inline-end:36px}}@media only screen and (min-width: 1280px){._28KHw38bf_5u1TG2iqsZyb{padding-inline-start:52px;padding-inline-end:52px}}._2CQPfU7oxrDLaWXtdC-a4E{margin-inline-start:20px;margin-inline-end:20px}@media only screen and (min-width: 480px){._2CQPfU7oxrDLaWXtdC-a4E{margin-inline-start:36px;margin-inline-end:36px}}@media only screen and (min-width: 1280px){._2CQPfU7oxrDLaWXtdC-a4E{margin-inline-start:52px;margin-inline-end:52px}}._1cCm6S7fIL2mm34Y94BZj3{z-index:6;box-sizing:border-box;position:fixed;top:24px;inset-inline-end:112px}._3z6QXL3qicNjCm6naP_zGC{z-index:6;box-sizing:border-box;position:fixed;top:24px;inset-inline-end:112px}\n", ""]);

// exports
exports.locals = {
	"grid-sides": "_28KHw38bf_5u1TG2iqsZyb",
	"gridSides": "_28KHw38bf_5u1TG2iqsZyb",
	"grid-sides-margins": "_2CQPfU7oxrDLaWXtdC-a4E",
	"gridSidesMargins": "_2CQPfU7oxrDLaWXtdC-a4E",
	"enter-fullscreen-component": "_1cCm6S7fIL2mm34Y94BZj3",
	"enterFullscreenComponent": "_1cCm6S7fIL2mm34Y94BZj3",
	"exit-fullscreen-component": "_3z6QXL3qicNjCm6naP_zGC",
	"exitFullscreenComponent": "_3z6QXL3qicNjCm6naP_zGC"
};